import Link from 'components/link/Link';

import { IEmployeeSearchResult } from 'source/NFR.types';

const EmployeeSearchResult: React.FC<IEmployeeSearchResult> = ({ labeledLinks = [], subTitle, title }) => (
  <div className="employee-search-result">
    {title && <h3>{title}</h3>}

    {subTitle && <h4>{subTitle}</h4>}

    {labeledLinks?.length > 0 && (
      <ul className="employee-search-result--links">
        {labeledLinks.map(({ label, link }) => (
          <li key={label}>
            <span>{label}: </span>
            {link?.url ? <Link {...link} theme="underline" /> : <span>{link?.text}</span>}
          </li>
        ))}
      </ul>
    )}
  </div>
);

EmployeeSearchResult.displayName = 'EmployeeSearchResult';

export default EmployeeSearchResult;
